import React from "react";
import { Mail, MessageCircle } from "lucide-react"; // MessageCircle for WhatsApp icon

export default function ContactUs() {
  const brandGreen = "#1ac942";
  const glowStyle = "0 8px 30px rgb(26 201 66 / 33%)";

  return (
    <section
      style={{
        backgroundColor: "black",
        color: "whitesmoke",
        padding: "80px 20px",
        textAlign: "center",
        fontFamily: "Inter, Arial, sans-serif",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <h1
          style={{
            fontSize: "clamp(32px, 5vw, 42px)",
            fontWeight: "900",
            marginBottom: "12px",
            color: brandGreen, // Brand consistency
            textTransform: "uppercase",
          }}
        >
          Contact Us
        </h1>
        <h4
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#aaa",
            marginBottom: "40px",
          }}
        >
          Get in Touch with BioSurge
        </h4>

        {/* WhatsApp Quick Connect Card */}
        <div 
          style={{
            marginBottom: "40px",
            padding: "25px",
            borderRadius: "12px",
            backgroundColor: "rgba(26, 201, 66, 0.1)",
            border: `1px solid ${brandGreen}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px",
            boxShadow: glowStyle
          }}
        >
          <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>Fastest Response via WhatsApp</h5>
          <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>Available Mon-Sat: 10 AM - 8 PM</p>
          <a 
            href="https://wa.me/917992151205?text=Hi+BioSurge%21+I+have+a+query+regarding..." 
            target="_blank" 
            rel="noreferrer"
            style={{
              backgroundColor: brandGreen,
              color: "black",
              padding: "12px 30px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "800",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "16px"
            }}
          >
            <MessageCircle size={20} /> CHAT ON WHATSAPP
          </a>
        </div>

        <div
          style={{
            textAlign: "left",
            backgroundColor: "#050505",
            color: 'whitesmoke',
            borderRadius: "15px",
            boxShadow: glowStyle,
            padding: "40px",
            border: "1px solid #1b5e20"
          }}
        >
          {/* Order Support */}
          <div style={{ marginBottom: "35px" }}>
            <h5 style={styles.cardHeading}>Orders, Returns & Exchanges</h5>
            <p style={styles.cardText}>
              Please review our Return/Exchange Policy prior to reaching out.
            </p>
            <a href="mailto:biosurge01@gmail.com" style={styles.mailLink}>
              <Mail size={18} color={brandGreen} /> biosurge01@gmail.com
            </a>
          </div>

          {/* Bulk Orders */}
          <div style={{ marginBottom: "35px" }}>
            <h5 style={styles.cardHeading}>Bulk Orders & Partnerships</h5>
            <p style={styles.cardText}>
              Planning a corporate event or festival gifting? Let’s collaborate.
            </p>
            <a href="mailto:biosurge01@gmail.com" style={styles.mailLink}>
              <Mail size={18} color={brandGreen} /> biosurge01@gmail.com
            </a>
          </div>

          {/* Media */}
          <div>
            <h5 style={styles.cardHeading}>Media & Collaborations</h5>
            <p style={styles.cardText}>
              For press inquiries, product features, or collaboration ideas.
            </p>
            <a href="mailto:biosurge01@gmail.com" style={styles.mailLink}>
              <Mail size={18} color={brandGreen} /> biosurge01@gmail.com
            </a>
          </div>
            <div>
            <h5 style={styles.cardHeading}>Address</h5>
            <p style={styles.cardText}>
             house no. 27, 1st floor, Hariomnagar, Aligarh Uttarpradesh - 202002
            </p>
          
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  cardHeading: {
    color: "whitesmoke",
    fontSize: "19px",
    fontWeight: "700",
    marginBottom: "10px",
  },
  cardText: {
    marginBottom: "8px",
    color: "#aaa",
    fontSize: "15px",
    lineHeight: "1.6"
  },
  mailLink: {
    color: "#fff",
    textDecoration: "underline",
    fontWeight: "600",
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "15px"
  }
};